var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row pt-2 pb-2 pl-5 pr-5" }, [
        _c("div", { staticClass: "col-auto mr-auto" }, [
          _c("div", { staticClass: "navbar-header" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "navbar-brand", attrs: { id: "lco-name" } },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.pageTitle) + "\n          "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto" }, [
          _c(
            "span",
            [
              _c("time-panel", {
                attrs: {
                  "current-timestamp": _vm.currentTimestamp,
                  "start-timestamp": _vm.startTimestamp,
                  "end-timestamp": _vm.endTimestamp
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid intro downPage blue" }, [
      _c("div", { staticClass: "row pt-2 pb-2 pl-5 pr-5" }, [
        _c("div", { staticClass: "col" }, [
          _c("span", { staticClass: "welcome-text welcome-text-big" }, [
            _vm._v(_vm._s(_vm.leftText) + " ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col right-aligned" },
          _vm._l(_vm.links, function(link) {
            return _c(
              "span",
              [
                link.target.startsWith("#")
                  ? [
                      _c(
                        "a",
                        {
                          staticClass: "link-text pl-4",
                          attrs: {
                            "data-toggle": "modal",
                            "data-target": link.target,
                            href: ""
                          }
                        },
                        [_vm._v(_vm._s(link.text))]
                      )
                    ]
                  : [
                      _c(
                        "router-link",
                        {
                          staticClass: "link-text pl-4",
                          attrs: { to: link.target }
                        },
                        [_vm._v(_vm._s(link.text))]
                      )
                    ]
              ],
              2
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "navbar-brand",
        attrs: { href: "https://lco.global", title: "LCO.global", rel: "home" }
      },
      [
        _c("img", {
          attrs: {
            id: "lco-logo",
            src: "https://cdn.lco.global/mainstyle/img/LCO-logo-web.jpg",
            alt: "Las Cumbres Observatory"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }